import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { NoTranscript } from "~/components/AssetModalV2/Content/Panel/Transcript/NoTranscript";
import { TranscriptLoadingSkeleton } from "~/components/AssetModalV2/Content/Panel/Transcript/TranscriptLoadingSkeleton";
import { TranscriptProcessing } from "~/components/AssetModalV2/Content/Panel/Transcript/TranscriptProcessing";
import { TranscriptSegmentsList } from "~/components/AssetModalV2/Content/Panel/Transcript/TranscriptSegmentsList";
import { TranscriptScrollInfoProvider } from "~/providers/TranscriptScrollInfoProvider";
export const transcriptProgressStatuses = [
    "processing",
    "dispatched",
    "pending"
];
export const TranscriptPanel = /*#__PURE__*/ memo((param)=>{
    let { transcriptRanges, isInitialLoading, Search, transcriptStatus, hasMore, durationMs, fetchTranscriptForRange } = param;
    if (isInitialLoading) {
        return /*#__PURE__*/ _jsx(TranscriptLoadingSkeleton, {});
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "h-screen overflow-auto",
        children: transcriptRanges.length === 0 ? /*#__PURE__*/ _jsx("div", {
            className: "p-6",
            children: transcriptProgressStatuses.includes(transcriptStatus) ? /*#__PURE__*/ _jsx(TranscriptProcessing, {}) : /*#__PURE__*/ _jsx(NoTranscript, {})
        }) : /*#__PURE__*/ _jsx("div", {
            className: "flex h-full flex-col",
            children: /*#__PURE__*/ _jsxs(TranscriptScrollInfoProvider, {
                children: [
                    /*#__PURE__*/ _jsx(Search, {}),
                    /*#__PURE__*/ _jsx(TranscriptSegmentsList, {
                        fetchTranscriptForRange: fetchTranscriptForRange,
                        durationMs: durationMs,
                        transcriptRanges: transcriptRanges,
                        hasMore: hasMore
                    })
                ]
            })
        })
    });
});
TranscriptPanel.displayName = "TranscriptPanel";
